import React, { createContext, useContext, useState } from 'react'
import { QueryClient, useQuery, useMutation } from '@tanstack/react-query'
import useTranslation from '../shared/TranslationProvider'
import { apiPatch } from '~/util/api'

export const queryClient = new QueryClient()

const SelectOnboardingContext = createContext()

export const useSelectOnboarding = () => useContext(SelectOnboardingContext)

export const SelectOnboardingProvider = ({ children }) => {
  const { t } = useTranslation()
  const [questionIdx, setQuestionIdx] = useState(0)
  const questions =
    t('SelectOnboarding.questions', { returnObjects: true }) || []
  const onLastQuestion = questionIdx === questions.length

  const { data } = useQuery({
    queryKey: ['welcome'],
    queryFn: () =>
      fetch('/onboarding/welcome')
        .then((res) => res.json())
        .then((data) => data),
  })

  const firstName = data?.firstName || ''

  const patchFn = (values) => {
    const data = {
      social_media_profile: {
        linked_in_profile_url: values.linked_in_url,
      },
      candidate: {
        candidate_profile_attributes: {
          career_goals: values.career_goals,
          ideal_timeline: values.ideal_timeline,
          support_needed: values.support_needed,
          support_needed_open_ended: values.support_needed_open_ended,
          target_role: values.target_role,
          seen_onboarding: true,
        },
      },
    }
    const res = apiPatch('/onboarding', data).then((res) => res.data)
    return res
  }

  const skipPatchFn = () => {
    const data = {
      candidate: { candidate_profile_attributes: { seen_onboarding: true } },
    }
    const res = apiPatch('/onboarding', data).then((res) => res.data)
    return res
  }

  const updateOnboardingMutation = useMutation({
    mutationFn: patchFn,
    onSuccess: () => {
      if (onLastQuestion) {
        window.location.href = '/'
        return
      }
      setQuestionIdx((idx) => idx + 1)
    },
    onError: (error) => {
      console.error('Error updating onboarding:', error)
    },
  })

  const skipOnboardingMutation = useMutation({
    mutationFn: skipPatchFn,
    onSuccess: () => {
      window.location.href = '/'
    },
    onError: (error) => {
      console.error('Error skipping onboarding:', error)
    },
  })

  const value = {
    questionIdx,
    questions,
    setQuestionIdx,
    firstName,
    updateOnboardingMutation,
    onLastQuestion,
    skipOnboardingMutation,
  }

  return (
    <SelectOnboardingContext.Provider value={value}>
      {children}
    </SelectOnboardingContext.Provider>
  )
}
